export const TITLE = {
  first: 'order cut-off time',
  second: 'Any expected order processing delay in the near future?',

};
export const DESC = {
  first: '',
  second: 'Let us know if you are expecting an upcoming fulfillment delay (i.e strikes, company holidays, etc), so we can factor that into your estimated delivery date.',
};
